import { render } from "./RemindersList.vue?vue&type=template&id=5a4315b9&scoped=true&lang=pug"
import script from "./RemindersList.vue?vue&type=script&lang=js"
export * from "./RemindersList.vue?vue&type=script&lang=js"

import "./RemindersList.vue?vue&type=style&index=0&id=5a4315b9&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4315b9"]])

export default __exports__